import { Component } from '@angular/core';
import { ElectronService } from './core/services';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { ipcRenderer } from 'electron';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  ipcRenderer!: typeof ipcRenderer;
  message:any = null;
  constructor(
    private electronService: ElectronService,
    private ngZone: NgZone,
    private router: Router
  ) {
    if (this.electronService.isElectron) {
      // console.log("response");
      this.ipcRenderer = (window as any).require('electron').ipcRenderer;
      this.ipcRenderer.on('notification-clicked', (event: any, response: any) => {
        // console.log(response);
        this.manageOrderData(response)
        console.log(response, 'notification clicked');
        
      });
    }
  }

  ngOnInit(): void {
    // this.requestPermission();
    // this.listen();
  }

  manageOrderData(response:any){
    this.ngZone.run(() => {

      let type = response.orderData.type
      let orderID = response.orderData.data.id
      let brodcast_order_id = response.orderData.data.order_id
      // console.log(response);

      if (type === 1) {

        this.router.navigate([`merchants/dashboard/order-request-detail/${brodcast_order_id}`]);
      } else if (type === 2) {


        this.router.navigate([`merchants/orders/details/${orderID}`])
      } else if (type === 3) {
        this.router.navigate([`merchants/orders/details/${orderID}`])
      }else if (type === 5) {


        this.router.navigate([`admin/orders/details/${orderID}`])
      }

    });
  }

  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, 
     { vapidKey: "BD-m3Ljxczv_4brThNmhQ-d3Cq_e-J7FiQ2FSPXRYqd2G_gfRr6mo-qdG32CaNI8XgwONQf6SXrXUnF1mWb-BTo"}).then(
       (fcmToken) => {
         if (fcmToken) {
          //  console.log("Hurraaa!!! we got the token.....");
          localStorage.setItem('fcm_token',fcmToken)
          sessionStorage.setItem('fcm_token',fcmToken)

          //  console.log(fcmToken);
         } else {
           console.log('No registration token available. Request permission to generate one.');
         }
     }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
  }
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message=payload;
    });
  }
}
